import draw from '@/api/administrator/draw-setting'
import prefix from '@/api/administrator/game-prefix'
import gameSetting from '@/api/administrator/game-setting'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return draw.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return draw.store(data)
  },
  update(context, { id, data }) {
    return draw.update(id, data)
  },
  destroy(context, id ) {
    return draw.destroy(id)
  },
  getGameSetting(context) {
    return gameSetting.get({
      params: {
        fields: {
          game_settings: 'game_setting,game_setting_id,game_type_id'
        },
        filter: {
          inactive: false
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGamePrefix(context) {
    return prefix.get({
      params: {
        fields: {
            game_prefixs: 'prefix_sample,prefix_id'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
}
